/**
 * isJSON
 * @param something
 * @returns {boolean}
 */
window.isJSON = function(something) {
  if (typeof something != 'string') {
    something = JSON.stringify(something);
  }

  try {
    JSON.parse(something);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * checkUstId
 * @param obj
 */
window.checkUstId = function(obj) {
  $('#checkid_result').html('').hide();
  $('.amazon-next-button').removeAttr('disabled').removeClass('disabled');

  $.ajax({
    url: MP_PATH + 'ajax/ajax.check_ust_id.php',
    type: 'get',
    data: {
      ustid: $(obj).val(),
    },
    success: function(html) {
      if (isJSON(html) === true) {
        var json_return = JSON.parse(html);
        $('#checkid_result').html('<div class="alert-inner">' + json_return.answer + '</div>').show();
        $('.amazon-next-button').attr('disabled', 'disabled').addClass('disabled');
      }
    },
  });
};
